import { apiClient } from '@/shared/api'
import { buildQueryString } from '@/shared/utils/buildQueryString'
import type { Result } from '@/shared/types'
import type { ApiError } from '@/shared/types/errors'
import type {
  ResourceItem,
  ResourceListResponse,
  ResourceSearchResponse,
  ResourceType,
  SyncAllResponse,
  SyncResult,
} from './types'

export async function fetchResources(
  resourceType?: ResourceType,
): Promise<Result<ResourceListResponse, ApiError>> {
  return apiClient.get<ResourceListResponse>(`/api/resources${buildQueryString({ resource_type: resourceType })}`)
}

export async function searchResources(
  query: string,
  resourceType?: ResourceType,
): Promise<Result<ResourceSearchResponse, ApiError>> {
  return apiClient.get<ResourceSearchResponse>(
    `/api/resources/search${buildQueryString({ q: query, resource_type: resourceType })}`,
  )
}

export async function getResource(
  id: string,
): Promise<Result<ResourceItem, ApiError>> {
  return apiClient.get<ResourceItem>(`/api/resources/${id}`)
}

export async function syncAll(): Promise<Result<SyncAllResponse, ApiError>> {
  return apiClient.post<SyncAllResponse>('/api/resources/sync')
}

export async function syncType(
  resourceType: ResourceType,
): Promise<Result<SyncResult, ApiError>> {
  return apiClient.post<SyncResult>(`/api/resources/sync/${resourceType}`)
}
